// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qPVzEB {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: var(--spacing-1-5);
  padding: var(--spacing-3) 0;
  margin-bottom: var(--spacing-3);
  border-bottom: 1px solid var(--stroke-neutral-subtle);
  font-family: var(--font-family-base);
}

.dUnhCN {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: var(--spacing-0-5);
}

.jU_atu {
  width: 100%;
  height: 2px;
  flex-shrink: 0;
}

.XVA2bu {
  background-color: var(--status-success);
}

.eL8Xyt {
  background-color: var(--surface-primary-medium);
}

.HDjJZe {
  background-color: var(--stroke-neutral-subtle);
}

.fMYjYI {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-1);
  width: 100%;
  box-sizing: border-box;
  padding: 0 var(--spacing-0-5);
}

.c8SXPX {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: var(--radius-pill);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.SjKx_5 {
  background-color: var(--status-success);
}

.UoNmwy {
  background-color: var(--surface-primary-medium);
}

.EtYzjs {
  border: 1px solid var(--stroke-neutral-stronger);
}

.kgws8v {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  line-height: 1;
}

.S63qvo {
  color: var(--text-neutral-white);
}

.S1OzJw {
  color: var(--text-neutral-stronger);
}

.OpHs8C {
  flex: 1 1 0;
  min-width: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  line-height: normal;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.G2XcLr {
  color: var(--status-success);
}

.sXaYns {
  color: var(--text-primary-medium);
}

.BwJxf8 {
  color: var(--text-neutral-stronger);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/WizardStepper/WizardStepper.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;EAC/B,qDAAqD;EACrD,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,8BAA8B;EAC9B,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":[".stepper {\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: var(--spacing-1-5);\n  padding: var(--spacing-3) 0;\n  margin-bottom: var(--spacing-3);\n  border-bottom: 1px solid var(--stroke-neutral-subtle);\n  font-family: var(--font-family-base);\n}\n\n.step {\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: var(--spacing-0-5);\n}\n\n.divider {\n  width: 100%;\n  height: 2px;\n  flex-shrink: 0;\n}\n\n.dividerCompleted {\n  background-color: var(--status-success);\n}\n\n.dividerActive {\n  background-color: var(--surface-primary-medium);\n}\n\n.dividerInactive {\n  background-color: var(--stroke-neutral-subtle);\n}\n\n.titleRow {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--spacing-1);\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0 var(--spacing-0-5);\n}\n\n.badge {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  border-radius: var(--radius-pill);\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.badgeCompleted {\n  background-color: var(--status-success);\n}\n\n.badgeActive {\n  background-color: var(--surface-primary-medium);\n}\n\n.badgeInactive {\n  border: 1px solid var(--stroke-neutral-stronger);\n}\n\n.badgeNumber {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-medium);\n  line-height: 1;\n}\n\n.badgeNumberOnFill {\n  color: var(--text-neutral-white);\n}\n\n.badgeNumberInactive {\n  color: var(--text-neutral-stronger);\n}\n\n.label {\n  flex: 1 1 0;\n  min-width: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-medium);\n  line-height: normal;\n  text-align: left;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.labelCompleted {\n  color: var(--status-success);\n}\n\n.labelActive {\n  color: var(--text-primary-medium);\n}\n\n.labelInactive {\n  color: var(--text-neutral-stronger);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepper": `qPVzEB`,
	"step": `dUnhCN`,
	"divider": `jU_atu`,
	"dividerCompleted": `XVA2bu`,
	"dividerActive": `eL8Xyt`,
	"dividerInactive": `HDjJZe`,
	"titleRow": `fMYjYI`,
	"badge": `c8SXPX`,
	"badgeCompleted": `SjKx_5`,
	"badgeActive": `UoNmwy`,
	"badgeInactive": `EtYzjs`,
	"badgeNumber": `kgws8v`,
	"badgeNumberOnFill": `S63qvo`,
	"badgeNumberInactive": `S1OzJw`,
	"label": `OpHs8C`,
	"labelCompleted": `G2XcLr`,
	"labelActive": `sXaYns`,
	"labelInactive": `BwJxf8`
};
module.exports = ___CSS_LOADER_EXPORT___;
